import type { HeaderPaneName } from "owa-app-pane-group-types";
import { headerPaneNames } from "owa-app-pane-group-types";

const headerPaneNamesSet = new Set<string>(headerPaneNames);

export default function isHeaderPane(paneName: string): paneName is HeaderPaneName {
    return headerPaneNamesSet.has(paneName);
}
